import React from "react";
import PropTypes from "prop-types";

function CompanyImage(props) {
  const { company, defaultCompanyImage } = props;

  const ImageTag = ({company, defaultCompanyImage}) => {
    const image = company.logo_image ? company.logo_image : defaultCompanyImage;
    return (
      <img alt={company.name} className='m-auto d-block' src={image} />
    );
  };

  return (
    <a href={`companies/${company.url_path_name}`} data-turbolinks='false'>
      <ImageTag
        company={company}
        defaultCompanyImage={defaultCompanyImage}
      />
    </a>
  );
}

CompanyImage.propTypes = {
  company: PropTypes.shape({
    name: PropTypes.string.isRequired,
    url_path_name: PropTypes.string.isRequired,
    logo_image: PropTypes.string,
  }).isRequired,
  defaultCompanyImage: PropTypes.string.isRequired
};

export default CompanyImage;
